const ANIMATION_MODE = {
    PLAY_FRAME: 0,
    TRANSLATE: 1
}

export {
    ANIMATION_MODE
}